<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>换货查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freight_bill_code">
                <el-input v-model="searchform.freight_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="outbill_code">
                <el-input v-model="searchform.outbill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batch_no">
                <el-input v-model="searchform.batch_no" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-select
                  v-model="searchform.product_code"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="旧码" prop="qrcode_old">
               <el-input v-model="searchform.qrcode_old" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新码" prop="qrcode_new">
               <el-input v-model="searchform.qrcode_new" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装级别" prop="packageLevel">
                 <el-select
                  v-model="searchform.package_level"
                  style="width:100%"
                  clearable
                  placeholder="请选择包装级别"
                >
                  <el-option
                    v-for="item in package_level"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="扫码日期" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                            value-format="yyyy-MM-dd"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['barter_select']">搜索</el-button>
              <el-button
              v-permission="['barter_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>换货查询</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="freight_bill_code" label="运单号" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outbill_code" label="出库单号" min-width="110" show-overflow-tooltip></el-table-column>
             <el-table-column prop="batch_no" label="批次号"  min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer" label="客户" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_old" label="旧码" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_new" label="新码" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level" label="包装级别" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="scan_time" label="扫码时间" min-width="140" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { selectoutbillorderbarter } from "@/api/physical";
import { productlist } from "@/api/base";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata({channelType:0});
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      productloading: false,
      show: false,
      productlist: [], //产品列表下拉
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      channelType:[
        {
          value:0,
          label:"配送中心"
        },
        {
          value:1,
          label:"退货仓"
        }
      ],
      package_level:[
        {
          value:1,
          label:"一级包装"
        },
        {
          value:2,
          label:"二级包装"
        }
      ],
      searchform: {
        batch_no:null,
        freight_bill_code: null,
        outbill_code:null,
        datelist:[],
        sscanTime : null,
        escanTime :null,
        package_level: null,
        product_code:null,
        qrcode_old:null,
        qrcode_new:null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
     // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectoutbillorderbarter(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData)
        this.currentPage = response.data.currPage;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    packdate(obj){// 拼装数据
              for (let i = 0; i < obj.length; i++) {
          obj[i].scan_time =  this.$parseTime(obj[i].scan_time);
          obj[i].product = (obj[i].product_code || ' ' ) + (obj[i].product_name || ' ' );
          obj[i].dealer = (obj[i].dealer_code || ' ' ) + (obj[i].dealer_name || ' ' );
                  switch (obj[i].package_level) {
           case 1: obj[i].package_level = "一级包装"            
             break;
             case 2: obj[i].package_level = "二级包装"
             break;      
           default:
             break;
         };
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          batch_no:this.searchform.batch_no,
        qrcode_old:this.searchform.qrcode_old,
        qrcode_new:this.searchform.qrcode_new,
        freight_bill_code: this.searchform.freight_bill_code,
        sscan_date :this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_date :this.searchform.datelist==null ? null:this.searchform.datelist[1],
        outbill_code: this.searchform.outbill_code,
        product_code:this.searchform.product_code,
        package_level:this.searchform.package_level,
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
      this.Tabledata({
        batch_no:this.searchform.batch_no,
        qrcode_old:this.searchform.qrcode_old,
        qrcode_new:this.searchform.qrcode_new,
        freight_bill_code: this.searchform.freight_bill_code,
        sscan_date :this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_date :this.searchform.datelist==null ? null:this.searchform.datelist[1],
        outbill_code: this.searchform.outbill_code,
        product_code:this.searchform.product_code,
        package_level:this.searchform.package_level,
        currPage:this.searchform.currPage,
        pageSize:this.searchform.pageSize
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
     this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        batch_no:this.searchform.batch_no,
        qrcode_old:this.searchform.qrcode_old,
        qrcode_new:this.searchform.qrcode_new,
        freight_bill_code: this.searchform.freight_bill_code,
        sscan_date :this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_date :this.searchform.datelist==null ? null:this.searchform.datelist[1],
        outbill_code: this.searchform.outbill_code,
        product_code:this.searchform.product_code,
        package_level:this.searchform.package_level,
      };
      selectoutbillorderbarter(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.packdate(this.tableDataDownload)
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "运单号",
            "出库单号",
            "批次号",
            "客户",
            "产品",
            "旧码",
            "新码",
            "包装级别",
            "扫码时间",
          ];
          const filterVal = [
            "freight_bill_code",
            "outbill_code",
            "batch_no",
            "dealer",
            "product",
            "qrcode_old",
            "qrcode_new",
            "package_level",
            "scan_time",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>